import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";

// Utils
import { ImageOrientation } from "../utils/image-orientation";
import { splitToChunks } from "../utils/split-to-chunks";

const Page = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: relative;

  & .column {
    grid-column: span 1;
    padding: 70px 0 0 0;

    width: 50vw;

    &.right {
      background-color: #dde1d4;
    }

    & .single-project-container {
      position: relative;
      width: 100%;

      overflow: hidden;

      margin: 2em 0;
      padding: 0 15px;

      /* padding: 0 0 30px 0; */
      /* cursor: none;

      & a {
        cursor: none;
      } */

      /* &.padded {
        padding: 0 30px 30px 30px;
      }

      &.image-portrait {
        padding: 90px 120px;
      } */
    }
  }

  & .mobile-caption {
    margin: 1em 0 0 0;

    & p {
      margin: 0;

      &.type {
        text-transform: capitalize;
      }
    }
  }

  @media (max-width: 999px) {
    display: block;
    grid-template-columns: unset;

    & .column {
      grid-column: unset;
      width: 100%;

      &.left {
        padding: 0;

        &:first-of-type {
          padding: 40px 0 30px 0;
        }
      }

      &.right {
        padding: 2em 0;

        & .single-project-container {
          margin: 0 0 2em 0;

          &:last-of-type {
            margin: 0;
          }
        }
      }

      & .single-project-container {
        padding: 0 15px;

        /* &.padded {
          &.image-landscape {
            // margin: 15px 0;
            padding: 15px;
          }

          &.image-portrait {
            // margin: 30px 0;
            padding: 30px 50px;
          }
        }

        &.image-portrait {
          // margin: 30px 0;
          // padding: 0 50px;
          padding: 30px 50px;
        } */
      }
    }
  }
`;

// const DesktopCaption = styled.div`
//   z-index: 100;

//   cursor: none;
//   pointer-events: none;

//   overflow: hidden;
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   cursor: none;

//   & p {
//     position: absolute;
//     margin: 0;

//     cursor: none;

//     font-size: 20px;
//     line-height: 125%;

//     /* font-size: 24px; */
//     /* line-height: 30px; */

//     transition: 50ms top ease, 50ms left ease;

//     & span {
//       color: #dde1d4;
//     }

//     @media (max-width: 1000px) {
//       font-size: 20px;
//       line-height: 125%;
//     }
//   }
// `;

export const HomepageMobile = ({ data }) => {
  const leftColumnProjects = data.prismicHomepage.data.left_column_projects
    .filter((project) => project.project.document !== null)
    .filter((project) => project.image.fluid !== null);

  const rightColumnProjects = data.prismicHomepage.data.right_column_projects
    .filter((project) => project.project.document !== null)
    .filter((project) => project.image.fluid !== null);

  const leftColumnSplitMobile = splitToChunks(leftColumnProjects, 2);
  const rightColumnSplitMobile = splitToChunks(rightColumnProjects, 2);

  const SingleProject = ({ project, index, order }) => {
    const projectType =
      project.project.type === "news_article" ? "news" : project.project.type;

    return (
      <div
        className={`single-project-container ${
          project.full_width ? `full-width` : `padded`
        } image-${ImageOrientation(project.image)}`}
      >
        <Link
          to={
            project.project.document.type === `project`
              ? project.project.url
              : `/news/`
          }
          state={{
            id: project.project.document.id,
          }}
        >
          <GatsbyImage
            image={project.image.gatsbyImageData}
            alt={project.image.alt}
            loading={order === 1 && index <= 2 ? `eager` : `lazy`}
          />
        </Link>

        <div className="mobile-caption">
          <p className="type">{projectType}</p>
          <p className="title">{project.project.document.data.title.text}</p>
        </div>
      </div>
    );
  };

  const leftColumnOne = leftColumnSplitMobile[0].map((content, index) => (
    <SingleProject
      project={content}
      key={`single_project_left_column_${index}_${content.project.document.id}`}
      index={index}
      order={1}
    />
  ));
  const leftColumnTwo = leftColumnSplitMobile[1].map((content, index) => (
    <SingleProject
      project={content}
      key={`single_project_left_column_${index}_${content.project.document.id}`}
      index={index}
      order={2}
    />
  ));

  const rightColumnOne = rightColumnSplitMobile[0].map((content, index) => (
    <SingleProject
      project={content}
      key={`single_project_left_column_${index}_${content.project.document.id}`}
      index={index}
      order={1}
    />
  ));
  const rightColumnTwo = rightColumnSplitMobile[1].map((content, index) => (
    <SingleProject
      project={content}
      key={`single_project_left_column_${index}_${content.project.document.id}`}
      index={index}
      order={2}
    />
  ));

  return (
    <Page>
      <div className="column left">{leftColumnOne}</div>
      <div className="column right">{rightColumnOne}</div>
      <div className="column left">{leftColumnTwo}</div>
      <div className="column right">{rightColumnTwo}</div>
    </Page>
  );
};
